export default __webpack_public_path__ + "static/favicon-d55f54f775663c4da731f1bc248647b1.png";